import React, { PureComponent } from 'react';
import classNames from 'classnames';
import Card from '../content/Card';
import { Header } from 'formlabs-web-components/Type';
import { Grid, Cell } from 'formlabs-web-components/Grid';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Button } from 'formlabs-web-components/Link';
import './webinars.module.css';
import { withTranslation } from 'react-i18next';

const WebinarList = DisplayComponent(
  class WebinarList extends PureComponent {
    render() {
      const {
        classes,
        styleNames,
        styles,
        webinars,
        t,
        page,
        hasNext,
        hasPrev
      } = this.props;

      const prev = parseInt(page, 10) - 1;
      const next = parseInt(page, 10) + 1;

      const listItems = webinars.map(webinar => (
        <Cell
          key={`${webinar.link} ${webinar.title}`}
          largeSize={8}
          mediumSize={12}
        >
          <Card
            url={webinar.webinarURL}
            eyebrowText={webinar.category}
            imageConstraint="150px"
            imagePosition="top"
            bgColor="transparent-black"
            image={webinar.image}
            padding="20px"
            webinars="true"
            hover="light-grey"
            classes="webinar-card"
            imageAlt={webinar.title}
          >
            <span styleName="runtime">{webinar.runtime}</span>
            <Header level={4} displayAs={5} weight={400}>
              {webinar.title}
            </Header>
            <p styleName="date">{webinar.date}</p>
            <p styleName="watch-now">{t('Watch Now')} ></p>
          </Card>
        </Cell>
      ));

      return (
        <div
          className={classes}
          styleName={classNames(styleNames)}
          style={styles}
        >
          <Grid direction="x" gutters="margin">
            {listItems}
          </Grid>
          <div styleName="pagination-wrapper">
            {hasPrev && (
              <Button
                color="light"
                rel="prev"
                url={prev > 0 ? `?page=${prev}` : null}
              >
                <i className="fl-arrow-left" /> {t('Previous')}
              </Button>
            )}
            {hasNext && (
              <Button
                styleName="pagination-button"
                color="light"
                rel="next"
                url={`?page=${next}`}
              >
                {t('Next')} <i className="fl-arrow-right" />
              </Button>
            )}
          </div>
        </div>
      );
    }
  }
);

export default withTranslation()(WebinarList);
